module.exports = __webpack_public_path__ + "static/img/qrCode2.63b27db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/qrCode2.png
// module id = Uu2/
// module chunks = 2